import logoAspaec from 'assets/img/aspaec/logotipo_topo.png'
import { QRCodeSVG } from 'qrcode.react'
import * as DocStyles from '../../styles'
import * as Styles from './styles'
import { useMembershipCard } from './useMembershipCard'

const ACCESS_URL = 'https://acesso.aspaec.com/AreaAssociados'
const SYSTEM_URL = 'https://sistema.aspaec.com/AreaAssociados'

export default function MembershipCard() {
  const { loading, downloading, card, frontRef, backRef, handleDownload } = useMembershipCard()

  return (
    <DocStyles.LawsuitSection>
      <DocStyles.LawsuitTitle>Carteira de associado / Salvo-conduto</DocStyles.LawsuitTitle>
      <DocStyles.LawsuitText>
        Apresente este documento para comprovar sua associação. Baixe a carteirinha em PDF quando precisar.
      </DocStyles.LawsuitText>

      {!card ? (
        <DocStyles.LawsuitUnavailable>
          {loading ? 'Carregando...' : 'Ainda não disponível. A carteira é liberada após a ativação da sua associação.'}
        </DocStyles.LawsuitUnavailable>
      ) : (
        <>
          <Styles.CardsWrapper>
            <Styles.CardFrame>
              <Styles.CardSide ref={frontRef} $variant="front">
                <Styles.FrontContent>
                  <img src={logoAspaec} alt="ASPAEC" />
                  <Styles.CardTitle>CARTEIRA DE ASSOCIADO</Styles.CardTitle>
                  <Styles.CardSubtitle>Documento de Identificação</Styles.CardSubtitle>
                  <Styles.InfoBox>
                    <Styles.InfoRow>
                      <Styles.InfoItem $full>
                        <span>NOME</span>
                        <strong>{card.name}</strong>
                      </Styles.InfoItem>
                      <Styles.InfoItem>
                        <span>CPF</span>
                        <strong>{card.cpf}</strong>
                      </Styles.InfoItem>
                      <Styles.InfoItem>
                        <span>DATA DE NASCIMENTO</span>
                        <strong>{card.birthday}</strong>
                      </Styles.InfoItem>
                    </Styles.InfoRow>
                  </Styles.InfoBox>
                </Styles.FrontContent>
              </Styles.CardSide>
            </Styles.CardFrame>

            <Styles.CardFrame>
              <Styles.CardSide ref={backRef} $variant="back">
                <Styles.BackContent>
                  <Styles.BackPanels>
                    <Styles.Panel>
                      <h4>CONTATO &amp; SUPORTE</h4>
                      <Styles.ContactList>
                        <li>
                          <strong>Local:</strong>Paulo Afonso/BA
                        </li>
                        <li>
                          <strong>CNPJ:</strong>59.049.432/0001-30
                        </li>
                        <li>
                          <strong>Telefone:</strong>(75) 99932-0420
                        </li>
                        <li>
                          <strong>E-mail:</strong>contato.aspaec@gmail.com
                        </li>
                      </Styles.ContactList>
                      <Styles.Compliance>
                        <div>
                          <strong>DOCUMENTAÇÃO MÉDICA REGULARIZADA</strong>
                          <p>
                            O associado possui receita e laudo médico válidos para aquisição de derivados de Cannabis
                            para uso medicinal/terapêutico.
                          </p>
                          <Styles.ComplianceNote>
                            EM CONFORMIDADE COM O PROCESSO Nº 1000873-17.2025.4.01.3306 CONCEDIDO PELA SSJ DO TRF-1 DA
                            JUSTIÇA FEDERAL
                          </Styles.ComplianceNote>
                        </div>
                      </Styles.Compliance>
                    </Styles.Panel>

                    <Styles.Panel>
                      <h4>ÁREAS DO ASSOCIADO</h4>
                      <Styles.QrList>
                        <Styles.QrItem>
                          <div>
                            <QRCodeSVG value={ACCESS_URL} level="M" fgColor="#02ad92" />
                          </div>
                          acesso
                        </Styles.QrItem>
                        <Styles.QrItem>
                          <div>
                            <QRCodeSVG value={SYSTEM_URL} level="M" fgColor="#02ad92" />
                          </div>
                          sistema
                        </Styles.QrItem>
                      </Styles.QrList>
                      <Styles.UrlList>
                        <span>acesso.aspaec.com/AreaAssociados</span>
                        <span>sistema.aspaec.com/AreaAssociados</span>
                      </Styles.UrlList>
                    </Styles.Panel>
                  </Styles.BackPanels>

                  <Styles.BackFooter>
                    <strong>www.aspaec.com</strong>
                    <small>
                      Válida até: {card.validUntil} | Emissão: {card.issuedAt}
                    </small>
                  </Styles.BackFooter>
                </Styles.BackContent>
              </Styles.CardSide>
            </Styles.CardFrame>
          </Styles.CardsWrapper>

          <Styles.DownloadButton type="button" onClick={handleDownload} disabled={downloading}>
            {downloading ? 'Gerando...' : 'Baixar carteirinha'}
          </Styles.DownloadButton>
        </>
      )}
    </DocStyles.LawsuitSection>
  )
}
